// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".cvat-dropdown-menu-paper{display:flex;flex-direction:column;background:#fff;padding:8px;border-radius:4px;box-shadow:0 3px 6px -4px rgba(0,0,0,.12),0 6px 16px 0 rgba(0,0,0,.08),0 9px 28px 8px rgba(0,0,0,.05)}.cvat-dropdown-menu-paper>*{width:100%}.cvat-dropdown-menu-paper>*:not(:first-child){margin-top:8px}.cvat-dropdown-menu-paper>* .ant-upload{width:100%}.cvat-dropdown-menu-paper>* .ant-upload button{width:100%}", ""]);
// Exports
module.exports = exports;
